import styled from 'styled-components'

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  white-space: pre-line;
  word-break: break-word;
  text-align: justify;
`
export const Title = styled.h1`
  font-family: Roboto;
  font-weight: 900;
  font-size: 100px;
  line-height: 120px;
  width: 100%;
  display: flex;
  color: ${({ theme }) => theme.color.blackrussian};
  justify-content: center;
  align-items: center;
  align-self: auto;
  margin: 24px auto;
  @media (max-width: ${({ theme }) => theme.resolution.sm}) {
    font-size: 60px;
    line-height: 70px;
    margin: 15px auto;
    text-align: center;
  }
`
export const Img = styled.img`
  height: 200px;
`
export const Text = styled.p`
  font-family: Roboto;
  font-style: normal;
  font-weight: 900;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  color: #44444F;
  margin: 8px 0px;
  @media (max-width: ${({ theme }) => theme.resolution.sm}) {
    margin: 8px 5px;
  }
`
export const Hint = styled.div`
  position: static;
  width: 100%;
  height: 16px;
  left: 0px;
  top: 488px;

  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  text-align: center;

  color: #696974;
  margin: 32px 0px;
`
export const Support = styled.div`
  position: static;
  height: 16px;
  left: 0px;
  right: 0px;
  top: 621px;

  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  text-align: center;

  color: #92929D;
  margin: 40px 0px;
`
export const ButtonWrap = styled.div`
  padding-top: 24px;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  grid-gap: 16px;
  @media (max-width: ${({ theme }) => theme.resolution.sm}) {
    flex-wrap: wrap;
  }
`
